module.exports = __webpack_public_path__ + "img/roof-mixed.adfca0c1.svg";